import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import NavStore from "../stores/NavStore";
import { requestNav } from "../state/navSlice";
export function RequestNav(navDestination, element) {
  let list = NavStore.getListenCount();
  if (list === 0) {
    let link = document.getElementById(element);
    link.click();
  }
  dispatcher.dispatch({
    actionType: actionTypes.NavRequest,
    Result: {
      dest: navDestination,
      el: element
    }
  });
}
export function RequestNav2(navDestination, navPath, dispatch) {
  dispatch(requestNav({ navDestination, navPath }));
}
export function AcceptNav() {
  let el = NavStore.getElement();
  let link = document.getElementById(el);
  link.click();
}
